import React from "react";
import "./promo.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import promoimages from "../../asset/promo/promo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faMedal } from "@fortawesome/free-solid-svg-icons";

const Promo = () => {
  const wapromo = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285212538280&text=Halo+Dennys%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(promo)%20https://agungsedayu-pik2.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyload: true,
    autoplay: true,
    autoplayspeed: 1000,
  };
  return (
    <div id="promo" className="container-promo">
      <div className=" container-listpromo">
        <div className="containercontent">
          <div className="judul-promo">
            PROMO KESELURUHAN PANTAI INDAH KAPUK 2
          </div>
          <div className="pointpenawaran">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faMedal} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Soft DP</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faMedal} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Discount up to 5%
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faMedal} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Free Canopy</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faMedal} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Cicil Developer up to 120x{" "}
              </span>
            </div>
          </div>
          <div className="disclaimer">*Disclaimer</div>
          <div className="button-wa-promo">
            <button onClick={wapromo} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Get More Promo
            </button>
          </div>
        </div>
        <div className="containergambar">
          <Slider {...settings}>
            {promoimages.map((image, index) => (
              <img
                className="penawarangambar"
                key={index}
                src={image}
                alt="fasilitas"
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Promo;
